import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoadingConfig } from './models/loading.model';

@Injectable()
export class LoadingService {
    isEnabled: boolean;

    private _loadingStatus$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _loadingCounterRequest: number[] = [];

    constructor(config: LoadingConfig) {
        this.isEnabled = config.enabled;
    }

    showLoader(time?: number) {
        this._loadingCounterRequest.push(Date.now());
        this._loadingStatus$.next(true);

        if (time) {
            setTimeout(() => {
                this.hideLoader();
            }, time);
        }
    }

    hideLoader() {
        this._loadingCounterRequest.pop();
        if (this._loadingCounterRequest.length === 0) {
            this._loadingStatus$.next(false);
        }
    }

    getLoaderStatus() {
        return this._loadingStatus$.asObservable();
    }
}
